module.exports = __webpack_public_path__ + "static/media/PXMKIII-2-Ranger.eec501be.webp";